(function () {
    'use strict';

    angular.module("imApp").factory("productCalcService", ['$ihttp', function ($ihttp) {
        let service = {
            getProductCalc: function (parms) {
                return $ihttp.post({
                    method: 2413,
                    parameters: parms || {}
                });
            },
            createOrderLine: function (setting) {
                return $ihttp.post({
                    method: 2414,
                    parameters: setting
                });
            },
            listPriceList: function (parms) {
                return $ihttp.post({
                    method: 3405,
                    parameters: parms || {}
                });
            },
            changeColumn: function (setting) {
                return $ihttp.post({
                    method: 3852,
                    parameters: setting
                });
            },
            changePriceList: function (setting) {
                return $ihttp.post({
                    method: 3851,
                    parameters: setting
                });
            },
            updateOrderLine: function (setting) {
                return $ihttp.post({
                    method: 3615,
                    parameters: setting
                });
            },
            saveObj: function (setting) {
                return $ihttp.post({
                    method: 3850,
                    parameters: setting
                });
            }
        };

        return service;
    }]);
})();
